import { DropdownMenuOption } from '../../../../components/DropdownMenu/DropdownMenu';
import { parseTextMaxLength } from '../../../../components/FormComponents/utils/functions';
import {
  AccountAdminData,
  CANADIAN_PROVINCES_MAP,
  COUNTRIES_MAP,
  EMAIL_REGEX,
  NON_US_STATE,
  STATES_MAP,
} from '../../../../state/enrollment/enrollmentModel';

export const parseStreetAddress = (value: string) =>
  parseTextMaxLength(value, 40);
export const parseAddressCity = (value: string) =>
  parseTextMaxLength(value, 30);
export const parseAddressZip = (value: string) => parseTextMaxLength(value, 10);
export const parsePhoneNumber = (value: string) => {
  const sanitizedValue = value.replace(/[-\s]/g, '');
  const trimmedValue = parseTextMaxLength(sanitizedValue, 20);

  let result = '';
  let index = 0;

  for (const char of value) {
    if (char === '-' || char === ' ') {
      result += char;
    } else if (index < trimmedValue.length) {
      result += trimmedValue[index];
      index++;
    }
  }

  return result;
};

export const getStateOpts = (): DropdownMenuOption[] => {
  const statesOptions: DropdownMenuOption[] = Object.keys(STATES_MAP).map(
    (code: string) => ({
      value: code,
      label: STATES_MAP[code],
    })
  );
  const noneOption: DropdownMenuOption = {
    value: NON_US_STATE,
    label: 'None',
  };
  return [...statesOptions, noneOption];
};

export const getCountryOpts = (): DropdownMenuOption[] => {
  const countriesOptions: DropdownMenuOption[] = Object.keys(COUNTRIES_MAP).map(
    (code: string) => ({
      value: code,
      label: COUNTRIES_MAP[code],
    })
  );
  const canadianProvincesOptions: DropdownMenuOption[] = Object.keys(
    CANADIAN_PROVINCES_MAP
  ).map((code: string) => ({
    value: code,
    label: CANADIAN_PROVINCES_MAP[code],
  }));
  return [...countriesOptions, ...canadianProvincesOptions];
};

export const validateAccountAdminForm = (values: AccountAdminData) => {
  const errors: any = {};
  const phoneNumberRegex =
    /^(?:\d{1,3}[- ]?)?(?:\d{1,4}[- ]?)?\d{1,4}(?:[- ]?\d{1,4}){1,3}$/;

  if (!values.email) {
    errors.email = 'Email cannot be empty';
  } else if (!EMAIL_REGEX.test(values.email)) {
    errors.email = 'Email address improper formatting.';
  }
  if (!values.firstName) {
    errors.firstName = 'First name cannot be empty';
  }
  if (!values.lastName) {
    errors.lastName = 'Last name cannot be empty';
  }
  if (!values.addressLine1) {
    errors.addressLine1 = 'Business address street cannot be empty';
  }
  if (!values.city) {
    errors.city = 'Business address city cannot be empty';
  }
  if (!values.zipCode) {
    errors.zipCode = 'Business address zip cannot be empty';
  }
  if (!values.phoneNumber) {
    errors.phoneNumber = 'Business phone number cannot be empty';
  } else if (
    !phoneNumberRegex.test(values.phoneNumber) ||
    values.phoneNumber.length < 8
  ) {
    errors.phoneNumber = 'Business phone number is invalid';
  }
  if (!values.state) {
    errors.state = 'Business state/territory cannot be empty';
  }
  if (!values.country) {
    errors.country = 'Business province/country cannot be empty';
  }

  return errors;
};

export const isUSState = (stateCode: string) => {
  const stateCodes: string[] = Object.keys(STATES_MAP);
  return stateCodes.includes(stateCode);
};
